export const BOOKED_REVENUE_TITLE = "Booked Revenue";
export const BOOKED_REVENUE_CHART_COLOR = "#6C8EEF";
export const BOOKED_REVENUE_GRADIENT_ID = "revCurrent";

export const BOOKED_REVENUE_TOOLTIP_STYLE = {
  contentStyle: {
    borderRadius: "0.75rem",
    border: "1px solid #e2e8f0",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.08)",
    backgroundColor: "#ffffff",
  },
  labelStyle: {
    color: "#6c757d",
    fontSize: 12,
  },
};

export function formatRevenueAxisLabel(value) {
  return `$${(Number(value || 0) / 1000).toFixed(2)}k`;
}

export function formatRevenueTooltipValue(value) {
  return `$${Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatRevenueCurrency(value) {
  return `$${Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
